import { render } from "./HeaderControl.vue?vue&type=template&id=4c3cb4ea&scoped=true"
import script from "./HeaderControl.vue?vue&type=script&lang=js"
export * from "./HeaderControl.vue?vue&type=script&lang=js"

import "./HeaderControl.vue?vue&type=style&index=0&id=4c3cb4ea&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3cb4ea"]])

export default __exports__